import { useRef, useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import SplitText from '@/components/SplitText.jsx';

/**
 * Badge background grows horizontally; label text uses SplitText.
 */
export function HotspotOverlayBadge({ text, splitTextAnim }) {
  const wrapRef = useRef(null);
  const innerRef = useRef(null);
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (document.fonts.status === 'loaded') {
      setFontsLoaded(true);
    } else {
      document.fonts.ready.then(() => setFontsLoaded(true));
    }
  }, []);

  useGSAP(
    () => {
      const wrap = wrapRef.current;
      const inner = innerRef.current;
      if (!wrap || !inner || !text || !fontsLoaded) return undefined;

      gsap.set(wrap, { width: 0 });
      const fullWidth = inner.offsetWidth;

      const tween = gsap.to(wrap, {
        width: fullWidth,
        duration: 0.65,
        ease: 'power3.out',
      });

      return () => {
        tween.kill();
      };
    },
    { dependencies: [text, fontsLoaded], scope: wrapRef }
  );

  return (
    <div className="hotspot-overlay__badge-wrap">
      <div ref={wrapRef} className="hotspot-overlay__badge-clip">
        <div ref={innerRef} className="hotspot-overlay__badge">
          <SplitText
            text={text}
            tag="span"
            splitType="chars"
            textAlign="left"
            className="hotspot-overlay__badge-label"
            nowrap
            smartWrap={false}
            startDelay={0}
            animReady
            {...splitTextAnim}
          />
        </div>
      </div>
    </div>
  );
}
